import { Fancybox } from "@fancyapps/ui";
document.addEventListener("turbo:load", () => {
  Fancybox.bind("[data-fancybox]", {
    Thumbs: {
      autoStart: false,
    },
  });
});
